module.exports = __webpack_public_path__ + "static/media/yangyang-10.jpeg";